var map = {
	"./Polygon_1.svg": 2104,
	"./angle-double-right.svg": 3650,
	"./angle-up.svg": 1620,
	"./arrow-down-fullsvg.svg": 9314,
	"./arrow-left.svg": 1833,
	"./arrow-narrow-right-tool.svg": 3199,
	"./beta.svg": 4863,
	"./black-angle-down.svg": 7350,
	"./black-left.svg": 88,
	"./black-right.svg": 9631,
	"./caret-down.svg": 7596,
	"./chat.svg": 5166,
	"./check.svg": 706,
	"./clear-all.svg": 4564,
	"./color-palette-tool.svg": 5085,
	"./comment-alt.svg": 6344,
	"./copy.svg": 7918,
	"./crown.svg": 8978,
	"./deafen.svg": 5306,
	"./draw.svg": 1587,
	"./edit.svg": 8377,
	"./ellipsis-circle.svg": 9598,
	"./empty-plus.svg": 9241,
	"./error.svg": 9687,
	"./exit-meeting.svg": 5850,
	"./expand.svg": 951,
	"./external-link-square.svg": 9304,
	"./fa-angle-down.svg": 6853,
	"./facebook.svg": 3902,
	"./gear-maintenance.svg": 8000,
	"./google.svg": 3984,
	"./grey-pencil.svg": 625,
	"./grey-smile.svg": 3362,
	"./grey-trash.svg": 6731,
	"./group.svg": 7548,
	"./groups.svg": 20,
	"./image-plus.svg": 1053,
	"./info-circle.svg": 8272,
	"./info.svg": 7292,
	"./load-more-users.svg": 1678,
	"./loading.svg": 659,
	"./logo.svg": 3190,
	"./logobeta.svg": 9374,
	"./long-right-arrow.svg": 3475,
	"./maintenance-key.svg": 3508,
	"./maintenance.svg": 2121,
	"./meeting-room.svg": 577,
	"./meeting-settings.svg": 9836,
	"./meeting.svg": 8914,
	"./menu-dots-vertical.svg": 6957,
	"./microphone.svg": 2834,
	"./mute.svg": 5122,
	"./notLoggedIn.svg": 7559,
	"./nut.svg": 3410,
	"./paper-plane.svg": 558,
	"./pencil-tool.svg": 5861,
	"./plus.svg": 3189,
	"./question.svg": 7435,
	"./rectangle-tool.svg": 7743,
	"./register.svg": 1981,
	"./save.svg": 3884,
	"./search.svg": 9262,
	"./settings.svg": 677,
	"./share.svg": 3906,
	"./sharescreen.svg": 187,
	"./single-user.svg": 8889,
	"./success.svg": 4398,
	"./times.svg": 7792,
	"./trash.svg": 967,
	"./user-add.svg": 4184,
	"./user.svg": 1816,
	"./users-crown.svg": 1603,
	"./video-cut.svg": 2161,
	"./video-normal.svg": 73,
	"./warning.svg": 9800,
	"./white-copy.svg": 3335,
	"assets/icons/Polygon_1.svg": 2104,
	"assets/icons/angle-double-right.svg": 3650,
	"assets/icons/angle-up.svg": 1620,
	"assets/icons/arrow-down-fullsvg.svg": 9314,
	"assets/icons/arrow-left.svg": 1833,
	"assets/icons/arrow-narrow-right-tool.svg": 3199,
	"assets/icons/beta.svg": 4863,
	"assets/icons/black-angle-down.svg": 7350,
	"assets/icons/black-left.svg": 88,
	"assets/icons/black-right.svg": 9631,
	"assets/icons/caret-down.svg": 7596,
	"assets/icons/chat.svg": 5166,
	"assets/icons/check.svg": 706,
	"assets/icons/clear-all.svg": 4564,
	"assets/icons/color-palette-tool.svg": 5085,
	"assets/icons/comment-alt.svg": 6344,
	"assets/icons/copy.svg": 7918,
	"assets/icons/crown.svg": 8978,
	"assets/icons/deafen.svg": 5306,
	"assets/icons/draw.svg": 1587,
	"assets/icons/edit.svg": 8377,
	"assets/icons/ellipsis-circle.svg": 9598,
	"assets/icons/empty-plus.svg": 9241,
	"assets/icons/error.svg": 9687,
	"assets/icons/exit-meeting.svg": 5850,
	"assets/icons/expand.svg": 951,
	"assets/icons/external-link-square.svg": 9304,
	"assets/icons/fa-angle-down.svg": 6853,
	"assets/icons/facebook.svg": 3902,
	"assets/icons/gear-maintenance.svg": 8000,
	"assets/icons/google.svg": 3984,
	"assets/icons/grey-pencil.svg": 625,
	"assets/icons/grey-smile.svg": 3362,
	"assets/icons/grey-trash.svg": 6731,
	"assets/icons/group.svg": 7548,
	"assets/icons/groups.svg": 20,
	"assets/icons/image-plus.svg": 1053,
	"assets/icons/info-circle.svg": 8272,
	"assets/icons/info.svg": 7292,
	"assets/icons/load-more-users.svg": 1678,
	"assets/icons/loading.svg": 659,
	"assets/icons/logo.svg": 3190,
	"assets/icons/logobeta.svg": 9374,
	"assets/icons/long-right-arrow.svg": 3475,
	"assets/icons/maintenance-key.svg": 3508,
	"assets/icons/maintenance.svg": 2121,
	"assets/icons/meeting-room.svg": 577,
	"assets/icons/meeting-settings.svg": 9836,
	"assets/icons/meeting.svg": 8914,
	"assets/icons/menu-dots-vertical.svg": 6957,
	"assets/icons/microphone.svg": 2834,
	"assets/icons/mute.svg": 5122,
	"assets/icons/notLoggedIn.svg": 7559,
	"assets/icons/nut.svg": 3410,
	"assets/icons/paper-plane.svg": 558,
	"assets/icons/pencil-tool.svg": 5861,
	"assets/icons/plus.svg": 3189,
	"assets/icons/question.svg": 7435,
	"assets/icons/rectangle-tool.svg": 7743,
	"assets/icons/register.svg": 1981,
	"assets/icons/save.svg": 3884,
	"assets/icons/search.svg": 9262,
	"assets/icons/settings.svg": 677,
	"assets/icons/share.svg": 3906,
	"assets/icons/sharescreen.svg": 187,
	"assets/icons/single-user.svg": 8889,
	"assets/icons/success.svg": 4398,
	"assets/icons/times.svg": 7792,
	"assets/icons/trash.svg": 967,
	"assets/icons/user-add.svg": 4184,
	"assets/icons/user.svg": 1816,
	"assets/icons/users-crown.svg": 1603,
	"assets/icons/video-cut.svg": 2161,
	"assets/icons/video-normal.svg": 73,
	"assets/icons/warning.svg": 9800,
	"assets/icons/white-copy.svg": 3335
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9566;